// axios 客户端 + 拦截器（架构 §3.2.5 错误响应统一结构）
import axios, { AxiosError, type AxiosInstance } from "axios";
import { message } from "antd";
import type { BizError } from "@/types/common";

const BASE_URL =
  import.meta.env.VITE_ADMIN_API_BASE ?? "/api/admin/v1";

export const http: AxiosInstance = axios.create({
  baseURL: BASE_URL,
  timeout: 30_000,
});

// 请求拦截器：注入 Bearer token + trace_id
http.interceptors.request.use((config) => {
  const token = localStorage.getItem("admin_access_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  const traceId =
    crypto.randomUUID?.() ??
    `${Date.now()}-${Math.random().toString(36).slice(2)}`;
  config.headers["X-Trace-Id"] = traceId;
  return config;
});

// 响应拦截器：统一 BizError 处理 + 401 跳登录
http.interceptors.response.use(
  (res) => res,
  (err: AxiosError<BizError>) => {
    const data = err.response?.data;
    if (data && typeof data === "object" && "code" in data) {
      const biz = data as BizError;
      // 401 触发登出
      if (err.response?.status === 401) {
        localStorage.removeItem("admin_access_token");
        localStorage.removeItem("admin_user");
        if (location.pathname !== "/login") {
          location.assign("/login");
        }
      } else if (biz.code !== "AUTH.REFRESH_REPLAY") {
        message.error(`${biz.code}: ${biz.message}`);
      }
    } else if (err.message) {
      message.error(err.message);
    }
    return Promise.reject(err);
  },
);
